import { useCallback, useState } from "react";

type DownloadFn = () => Promise<{ data?: { blob: Blob } | null }>;

export function useFileDownload(fetchFn: DownloadFn, filename: string) {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = useCallback(async () => {
    if (isDownloading) return;
    setIsDownloading(true);

    try {
      const result = await fetchFn();
      if (!result.data?.blob) return;

      const url = window.URL.createObjectURL(result.data.blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
    } finally {
      setIsDownloading(false);
    }
  }, [fetchFn, filename, isDownloading]);

  return { download, isDownloading };
}
